/**
 * Created by DynamicDog on 2016-12-05.
 *
 * Show a single etikett item with a background image and a label.
 */
import {Component,Input,ElementRef,ViewChild} from '@angular/core';
import {TranslateService} from '../services/translate.service';
import {EtikettService} from '../services/etikett.service';
var $ = window['$'];

@Component({
    selector: 'etikett',

    template: `
                <img class="etikett-background" [src]="getImagePath(index)">
				<div [ngClass]="getClass(index)" class="textoverlay etikett-label" [ngStyle]="{'font-size':etikett.fontSize+'px','height':getHeight()+'px'}">{{tempString}}</div>
                <textarea #labelArea type="text" [readonly]="readonly" maxlength="100" (keydown)="keydown($event)" (keyup)="keyup($event)" (ngModelChange)="modelChange($event)" [(ngModel)]="etikett.label" placeholder="{{translate.translate('SKRIV DIN TEXT HÄR')}}" class="etikett-label" [ngClass]="getClass(index)" [ngStyle]="{'font-size':etikett.fontSize+'px','height':getHeight()+'px'}"></textarea>
                
                    `,
})
export class EtikettComponent {
    @Input() etikett: any;
    @Input() index:number;
	@Input() readonly:boolean;
	@ViewChild('labelArea') private textArea : ElementRef; 
    div:any;
    tempString:string;
    area:string;
    initiated:boolean = false;
    private fontSizes:Array<number> = [
        8,
        9,
        10,
        11,
        12,
        14,
        16,
        18,
        24,
        28,
        32,
        36,
        40,
        48,
        56,
        64
    ];

    constructor(private translate:TranslateService,private etikettService:EtikettService,private elRef:ElementRef) {
    }

    ngOnInit() {
    }

    private getClass(index:number):string {
        var c = this.etikett.font;
        if(index !== this.etikett.image || this.readonly) {
            c += " clickable";
        }
        return c;
    }

    private getHeight() {
        var maxHeight = 170;
        switch(this.etikettService.shape) {
            case 'bordsplacering':
            maxHeight = 60;
            break;
            case 'flasketikett':
            maxHeight = 130;
            break;
            case 'locketikett':
            maxHeight = 110;
            break;
            default:
            maxHeight = 170;
            break;
        }
        var lineHeight = this.etikett.fontSize * 1.2;
        var maxLines = Math.floor(maxHeight / lineHeight);
        var height = lineHeight * maxLines;
        return maxHeight;
    }

    private getImagePath(index:number): string {
        return 'labels/'+this.etikettService.shape+'/'+this.etikett.mode+'/pattern-'+index+'-medium.png';
    }

    private getFittingFontSize(textarea:any,text:string):void {
        if(text.length === 0) {
            text = this.translate.translate('SKRIV DIN TEXT HÄR');
        }
        var linefeed = text.lastIndexOf('\r');
        if(linefeed === -1) {
            linefeed = text.lastIndexOf('\n');
        }
        if(linefeed >= 0) {
            if(linefeed === text.length -1) {
                text += ' ';
            }
        }
        var maxWidth = textarea.width();
        var maxHeight = textarea.height();


        var c = "etikett-label "+this.etikett.font;
        var fontSize;
        var div = $('<div id="temp" class="'+c+'"><span>'+text+'</span></div>');
        div.css({
            "width":textarea.width(),
            "height": textarea.height(),
            "display": "inline-block",
            "word-break": "word-break",
            "white-space": "pre-wrap"
        });

        var span = div.find("span");
        
        textarea.parent().append(div);

        fontSize = this.fontSizes[0];

        for(var i = this.fontSizes.length-1;i > 0; i--) {
            div.css({"font-size":this.fontSizes[i]+"px"});
            
            if(span.height() < maxHeight && span.width() < maxWidth) {
                fontSize = this.fontSizes[i];
                break;
            }
        }
        this.etikett.fontSize = fontSize;
        div.remove();
        
    }
    private modelChange(event) {
        var text = event;
        if(!text || !text.length) {
            text = this.translate.translate('SKRIV DIN TEXT HÄR');
        }

        var fontSize = this.getFittingFontSize($(this.textArea.nativeElement),text);  
        this.tempString = text;
	}
	
    private keydown(event) {
        var textarea = $(this.textArea.nativeElement);
        textarea.addClass("editing");
        this.tempString = textarea.val();
        if(!this.tempString.length) {
            this.tempString = this.translate.translate('SKRIV DIN TEXT HÄR');
            this.getFittingFontSize(textarea,this.tempString)
        }
        textarea.parent().find(".textoverlay").css("color","#000");

    }
    private keyup(event) {

        var textarea = $(this.textArea.nativeElement);
        var text = textarea.val();
        if(!text) {
            text = "";
        }
        var fontSize = this.getFittingFontSize(textarea,text);          

        textarea.removeClass("editing");
        textarea.parent().find(".textoverlay").css("color","rgba(0,0,0,0)");
         
    }
}


// WEBPACK FOOTER //
// ./app/etikett/etikett.component.ts